import React, { Component } from "react";

export class NotAuthenticated extends Component {
  render() {
    return (
      <div className="d-flex flex-column" style={{ minHeight: "100vh", backgroundColor: "#fff" }}>
        <div style={{ backgroundColor: "#f7fafb", borderBottom: "4px solid var(--primary-color)", minHeight: "70px" }} />

        <div className="flex-grow-1 d-flex align-items-center justify-content-center px-3">
          <div
            className="text-center"
            style={{
              backgroundColor: "#fff",
              border: "1px solid var(--fourth-color)",
              borderTop: "4px solid var(--primary-color)",
              borderRadius: "8px",
              padding: "40px 32px",
              maxWidth: "480px",
              width: "100%",
              boxShadow: "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
            }}
          >
            <h5 className="card-text" style={{ color: "var(--secondary-color)" }}>
              Não foi possível realizar a autenticação, tente novamente mais tarde.
            </h5>
          </div>
        </div>

        <div style={{ backgroundColor: "#172f33", minHeight: "60px" }} />
      </div>
    );
  }
}

export default NotAuthenticated;
